import { render, staticRenderFns } from "./_MarketReportResult_consumer.vue?vue&type=template&id=45f716d1&"
import script from "./_MarketReportResult_consumer.vue?vue&type=script&lang=js&"
export * from "./_MarketReportResult_consumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports